import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconType } from '@ng-icons/core';
import { LogService } from 'src/app/@shared/services/log/log.service';

type MatButtonType =
  | 'simple'
  | 'raised'
  | 'stroked'
  | 'flat'
  | 'icon'
  | 'fab'
  | 'mini-fab';

@Component({
    selector: 'mot-button',
    templateUrl: './mot-button.component.html',
    styleUrls: ['./mot-button.component.scss'],
    standalone: false
})
export class MotButtonComponent {
  @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @Input() matType: MatButtonType = 'simple';
  @Input() icon: IconType;
  @Input() text: string;
  @Input() color?: string | null;
  @Input() type: string = 'button';
  @Input() iconClass:
    | string
    | string[]
    | Set<string>
    | { [klass: string]: any };
  @Input() buttonClass:
    | string
    | string[]
    | Set<string>
    | { [klass: string]: any };
  @Input() textClass: string;
  @Input() disableRipple: boolean = false;
  @Input() disabled: boolean = false;
  @Input() style: { [klass: string]: any };
  @Input() tooltip: string;
  /** Accessibility: announced by screen readers (e.g. for icon-only buttons). */
  @Input() ariaLabel: string;
  /** Accessibility: e.g. 'menu' for menu trigger. */
  @Input() ariaHaspopup: string;
  /** Accessibility: true when menu/popup is open. */
  @Input() ariaExpanded: boolean;
  /**
   * Accessibility: id of the popup/dialog the button controls.
   * Pair with `ariaHaspopup` + `ariaExpanded` for disclosure buttons.
   * Only emit when the popup is in the DOM and has a unique id (avoid dangling refs).
   */
  @Input() ariaControls: string;
  /** Accessibility: e.g. 'menuitem' for menu items. */
  @Input() role: string;
  /**
   * a11y: marks the inner native <button> with the `cdkFocusInitial` attribute so
   * Angular CDK's FocusTrap.focusInitialElementWhenReady() targets this button
   * as the popup's initial focus target on open. Use on the close-X button at
   * the top of every popup (audit requirement: focus must land there first).
   */
  @Input() focusInitial: boolean = false;
}
